import React, { useState,  Fragment } from "react";
import {Grid} from "@material-ui/core";
import {Link, NavLink, withRouter} from "react-router-dom";
import ListItem from "@material-ui/core/ListItem";
import List from "@material-ui/core/List";
import MobileMenu from "../MobileMenu";
import Hidden from "@material-ui/core/Hidden";
import Logo from "../Logo";

import logo from "../../images/logo.svg";
import Logo2 from "../../images/Logo2.svg";

import './style.scss';

const Header = (props) => {


    const [showMobile, setShowMobile] = useState(false);

    return(
        <Grid className={`header ${!props.fixHeader ? 'fixedHeader' : ''}`}>
            <Grid
                container
                alignItems="center"
                justify="space-between"
                >
                <Grid item xs={4} lg={2}>
                    <Logo className={logo}
                        darkLogo={Logo2}
                        lightLogo={logo}
                        alt="Logo"
                        link="/"
                        isHeaderFix={!props.fixHeader}
                    />
                </Grid>
                <Hidden mdDown>
                    <Grid item xs={6} md={7}>
                        <Grid container justify={"center"} className="mainMenu">
                            <List>
                                <ListItem><NavLink to="/Our-Paystubs" exact activeClassName="active">Our Pay Stubs</NavLink></ListItem>
                                <ListItem><NavLink to="/Guide"> Guide </NavLink></ListItem>
                                <ListItem><NavLink to="/faq"> Faq </NavLink></ListItem>
                                <ListItem><NavLink to="/Pricing">Pricing</NavLink></ListItem>
                                <ListItem><NavLink to="/contact-us">Contact</NavLink></ListItem>
                            </List>
                        </Grid>
                    </Grid>
                </Hidden>
                <Hidden mdDown>
                    <Grid item xs={3} lg={3} sm={4} container alignItems="center" className="justify-md-flex-space-between" justify="flex-start">
                         <Fragment>
                            <Link src="https://www.onetwopay.ca/log-in"  className="cBtn cBtnOutline cBtnUppercase ml-10">Log In</Link>
                        </Fragment> `<Link src="/login" className="cBtn ">Create Pay Stub</Link>
                    </Grid>
                </Hidden>
                <Hidden lgUp>
                    <Grid item xs={6} sm={2} className="text-right">
                        <Grid className={`humbergur ${showMobile ? 'show' : ''}`} onClick={() => setShowMobile(!showMobile)}>
                            <span></span>
                            <span></span>
                            <span></span>
                        </Grid>
                    </Grid>
                </Hidden>
            </Grid>
            <MobileMenu showMobile={showMobile}  setShowMobile={setShowMobile} />
        </Grid>
    )
};

export default withRouter(Header);